import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { IntellioFormlyWrapperComponent } from './itc-formly-wrapper.component';
import { WrapperChangeDetectNotifierService } from './wrapper-change-detect-notifier.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'itc-formly-wrapper-panel',
  styleUrls: ['./section-wrapper.component.scss'],
  template: `
    <div class="section-wrapper" [attr.id]="field.id">
      @if (!props.hideBreak) {
        <hr />
      }
      <div
        [ngClass]="{
          'section-wrapper__form': true,
          'legacy-read-mode': props.legacyReadMode
        }"
        >
        <div class="section-wrapper__title">
          <span>{{ props.title }}</span>
          @if (props.diff) {
            <span class="section-wrapper__show-diff">{{
              props.diff
            }}</span>
          }
        </div>
        <ng-container #fieldComponent></ng-container>
        <div></div>
      </div>
    </div>
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class SectionWrapperComponent extends IntellioFormlyWrapperComponent {
  constructor(
    protected notifierService: WrapperChangeDetectNotifierService,
    protected cd: ChangeDetectorRef
  ) {
    super(notifierService, cd);
  }

  ngOnInit() {
    this.initChangeDetectSub();
  }
}
